import classNames from 'classnames'
import { ComponentProps, ReactElement } from 'react'

export function IconAddColumn(props: ComponentProps<'svg'>): ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={classNames(props.className, 'w-[1em] h-[1em]')}
    >
      <rect x="4" y="4" width="2.82353" height="14.1176" fill="currentColor" />
      <rect x="8.70605" y="4" width="2.82353" height="14.1176" fill="currentColor" />
      <rect x="13.4121" y="4" width="2.82353" height="7.52941" fill="currentColor" />
      <path
        d="M15.7363 16.9525H13.2201V15.4469H15.7363V12.91H17.242V15.4469H19.7651V16.9525H17.242V19.455H15.7363V16.9525Z"
        fill="currentColor"
      />
    </svg>
  )
}
